import { Box, Button, CircularProgress, IconButton, Popover, PopoverProps, useTheme } from '@material-ui/core';
import { Select, SelectArrowDownIcon, Typography } from '@room-match/shared-ui-components'; // Remove CloseIcon
import CloseIcon from 'shared/components/Icon/CloseIcon'; // Use talent-app level folder CloseIcon
import MediaBinModal from 'shared/components/MediaBinModal/MediaBinModal';
import React, { useEffect, useState } from 'react';
import IMedia from 'shared/interfaces/IMedia';
import { ISkill } from 'shared/interfaces/ISkills';
import { ButtonCont, CancelButton, MainCont, SelectButton, useStyles } from './Popovers.styles';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';

interface Props extends PopoverProps {
  skill: ISkill;
  close: VoidFunction;
  onSave: (skill: ISkill) => void;
}

const REQUIRED_MEDIA_EXPERT = 1;
const REQUIRED_MEDIA_INTERMEDIATE = 0;
const REQUIRED_MEDIA_NOVICE = 0;

const SelectPopover: React.FC<Props> = ({ skill, close, onSave, ...props }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [selectedProficiency, setSelectedProficiency] = useState<string>('N');
  const [medias, setmedias] = useState<IMedia[]>([]);
  const [showMedia, setShowMedia] = useState(false);
  const [showAttachedMedia, setShowAttachedMedia] = useState(false);
  const [saving, setsaving] = useState(true);

  useEffect(() => {
    setmedias(skill.media || []);
    setSelectedProficiency(skill.proficiency?.value || 'N');
    setsaving(false);
  }, [skill]);

  const handleChange = (e: any) => {
    setSelectedProficiency(e.target.value);
  };

  const handleSave = () => {
    setsaving(true);
    const proficiency = () => {
      switch (selectedProficiency) {
        case 'E':
          return {
            key: 'Expert / Professional',
            value: 'E',
          };
        case 'I':
          return {
            key: 'Intermediate',
            value: 'I',
          };
        default:
          return {
            key: 'Novice',
            value: 'N',
          };
      }
    };
    onSave({
      ...skill,
      media: medias,
      proficiency: proficiency() as any,
      is_selected: true,
    });
  };

  const isDisabled = () => {
    switch (selectedProficiency) {
      case 'E':
        if (medias.length < REQUIRED_MEDIA_EXPERT) {
          return true;
        }
        return false;
      case 'I':
        if (medias.length < REQUIRED_MEDIA_INTERMEDIATE) {
          return true;
        }
        return false;
      case 'N':
        if (medias.length < REQUIRED_MEDIA_NOVICE) {
          return true;
        }
        return false;
    }
  };

  return (
    <div>
      <Popover
        open={props.open}
        anchorEl={props.anchorEl}
        onClose={close}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          classes: { root: classes.popoverBox },
        }}
        style={{ borderRadius: 10 }}
      >
        <MainCont>
          <Box style={{ padding: 30, position: 'relative', backgroundColor: '!important' }}>
            <IconButton onClick={close} style={{ position: 'absolute', right: 10, top: 10 }}>
              <CloseIcon style={{ width: 15, height: 15 }} />
            </IconButton>
            <CustomTypography fontSize={24} fontWeight={700} style={{ textAlign: 'center', marginTop: 20 }}>
              Select Proficiency
            </CustomTypography>
            <CustomTypography style={{ textAlign: 'center' }}>{skill.key}</CustomTypography>
            <CustomTypography
              fontSize={12}
              style={{
                marginTop: 30,
                marginBottom: -10,
              }}
            >
              Proficiency
            </CustomTypography>
            <Select
              disabled={saving}
              className={classes.select}
              fullWidth
              variant="outlined"
              //   fullWidth
              data={[
                { value: 'N', key: 'Novice' },
                { value: 'I', key: 'Intermediate' },
                { value: 'E', key: 'Expert / Professional' },
              ]}
              value={selectedProficiency}
              // IconComponent={SelectArrowDownIcon}
              onChange={handleChange}
            />
            {/* {!!medias.length && ( */}
            <Box style={{ display: 'flex', alignItems: 'center', marginTop: 10, marginBottom: 20 }}>
              <p style={{ fontSize: 16 }}> {medias.length} Media Attached : </p>
              <Button
                disabled={!medias.length || saving}
                style={{ marginLeft: 10, border: '#3e8bff solid 1px ', backgroundColor: 'transparent' }}
                onClick={() => setShowAttachedMedia(true)}
              >
                View Media
              </Button>
            </Box>
            {/* )} */}
            {selectedProficiency !== 'N' && isDisabled() && (
              <Typography style={{ color: '#e34343' }}>
                Selected proficiency requires{' '}
                {selectedProficiency === 'E' ? REQUIRED_MEDIA_EXPERT : REQUIRED_MEDIA_INTERMEDIATE} media to save
              </Typography>
            )}
            <ButtonCont>
              <SelectButton variant="contained" color="primary" disabled={isDisabled() || saving} onClick={handleSave}>
                {saving ? (
                  <>
                    <CircularProgress color="inherit" style={{ width: 20, height: 20, marginRight: 5 }} /> Saving...
                  </>
                ) : (
                  'Save'
                )}
              </SelectButton>
              {/* {showMAttach() && ( */}
              <CancelButton disabled={saving} onClick={() => setShowMedia(true)}>
                Add Media
              </CancelButton>
              {/* )} */}
            </ButtonCont>
            {showMedia && (
              <MediaBinModal
                selected={medias}
                show={showMedia}
                close={() => setShowMedia(false)}
                setSelected={setmedias}
              />
            )}
            {showAttachedMedia && (
              <MediaBinModal
                attachedMedia
                selected={medias}
                show={showAttachedMedia}
                close={() => setShowAttachedMedia(false)}
                setSelected={setmedias}
              />
            )}
          </Box>
        </MainCont>
      </Popover>
    </div>
  );
};

export default SelectPopover;
